import {FILTER_CITIES} from "./actionTypes";

export const filterCities = (cities) => {
    console.log("CIUDADES",cities);
    return {type: FILTER_CITIES, cities};
}